<template>
  <Nav></Nav>
  <main class="account-new">
    <back-button></back-button>
    <AccountEditor :edit="false"></AccountEditor>
  </main>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import BackButton from '@/components/BackButton.vue';
import Nav from '@/components/Nav.vue';
import AccountEditor from '@/components/AccountEditor.vue';

export default defineComponent({
  name: 'NewAccount',
  components: {
    BackButton,
    Nav,
    AccountEditor,
  },
});
</script>